import { useSelector } from 'react-redux';

import { selectConfig, selectHasFiber, selectNetwork, selectNetworkIssues, selectUser } from '@app/redux';

import { DiagnosticCheck } from './diagnostic-check';
import { DiagnosticDefault } from './diagnostic-default';
import { DiagnosticError } from './diagnostic-error';
import { DiagnosticSuccess } from './diagnostic-success';
import { LoadingContent } from './loading-content';

type DiagnosticCardContentProps = {
  runDiagnosticHandler: (e: React.MouseEvent<HTMLElement>) => void;
  navigateToDiagnosticReport: (e: React.MouseEvent<HTMLElement>) => void;
};

export const DiagnosticCardContent = ({
  runDiagnosticHandler,
  navigateToDiagnosticReport,
}: DiagnosticCardContentProps) => {
  const { loading: loadingUser } = useSelector(selectUser);
  const { loadingConfig } = useSelector(selectConfig);
  const hasFiber = useSelector(selectHasFiber);

  const loading = loadingUser || loadingConfig;

  const { diagnosticData, loading: diagnosticResultLoading, error: diagnosticRunError } = useSelector(selectNetwork);

  const networkIssues = useSelector(selectNetworkIssues);

  if (loading) {
    return <LoadingContent />;
  }

  if (diagnosticResultLoading) {
    return <DiagnosticCheck />;
  }

  if (diagnosticRunError) {
    return <DiagnosticError />;
  }

  if (diagnosticData && !networkIssues) {
    return (
      <DiagnosticSuccess
        navigateToDiagnosticReport={navigateToDiagnosticReport}
        runDiagnosticHandler={runDiagnosticHandler}
      />
    );
  }

  return <DiagnosticDefault showButton={!hasFiber} runDiagnosticHandler={runDiagnosticHandler} />;
};
